import { render, staticRenderFns } from "./ThumbItemImage.vue?vue&type=template&id=52c56b8d&scoped=true&"
import script from "./ThumbItemImage.vue?vue&type=script&lang=js&"
export * from "./ThumbItemImage.vue?vue&type=script&lang=js&"
import style0 from "./ThumbItemImage.vue?vue&type=style&index=0&id=52c56b8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c56b8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFileInput,VIcon})
